import React from "react";
import { SavingsGoals } from "../../types/FinanceData";
import { formatBalance } from "../../utils/formatBalance";
import "./Spaces.css";

interface Props {
  savingsGoals: Array<SavingsGoals>;
}

export const Spaces: React.FC<Props> = ({ savingsGoals }) =>
  savingsGoals.map((savingsSpace, index) => (
    <div className="container" key={index}>
      <h2 className="title">{savingsSpace.name}</h2>
      <div>{formatBalance(savingsSpace.totalSaved.minorUnits)}</div>
    </div>
  ));
